import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AppComponent } from '../component';
import rp from '@reporting/rp-app-host';

@customElement('rp-app-logo')
export class Logo extends AppComponent {

	static styles = css`
		.logo {
			height: 100%;
			width: 100%;
			text-align: center;
			container-type: inline-size;
		}

		.logo img {
			height: 40px;
			font-size: 26px;
			color: var(--og-accent-color);
		}

		.logo img.logo-square {
			display: block;
		}

		.logo img.logo-wide {
			display: none;
		}

		@container (width > 100px) {
			.logo img.logo-square {
				display: none;
			}
			.logo img.logo-wide {
				display: block;
			}
		}
	`;

	render = () =>html`
		<div class="logo" style=";">
			<img class="logo-square" src="${rp.options.staticUrl}/assets/logo-square-1.svg" alt="Reporting.cz" />
			<img class="logo-wide" src="${rp.options.staticUrl}/assets/logo-rect-1.svg" alt="Reporting.cz" />
		</div>
	`;

}
